import { render, staticRenderFns } from "./YearPrice.vue?vue&type=template&id=ec9e77ae&scoped=true&"
var script = {}
import style0 from "./YearPrice.vue?vue&type=style&index=0&id=ec9e77ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9e77ae",
  null
  
)

export default component.exports